export default __webpack_public_path__ + "static/media/default-logo.0e48b8eafa9799c4ffc70bcc5ece0d2a.svg";